import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import "./PaymentForm.css";
import Navbar from "./Navbar";
import BusinessLogin from "./BusinessLogin"

// Definice vzhledu pro Stripe
const appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#0570de',
    colorBackground: '#ffffff',
    colorText: '#30313d',
    colorDanger: '#df1b41',
    fontFamily: 'Ideal Sans, system-ui, sans-serif',
    spacingUnit: '2px',
    borderRadius: '4px',
  },
};

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const AdminPaymentForm = () => {
  const plan = "monthly";
  const [message, setMessage] = useState("");
  const { businessAdminToken, adminBusiness, fetchBusinessAdmin } = useAuth();  // Změněné zde
  const stripe = useStripe();
  const elements = useElements();
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (businessAdminToken && adminBusiness) {  // Nahrazeno
      const getPaymentData = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/payments/info-branch-subscribe`,
            {
              params: {
                businessId: adminBusiness._id,       // Nahrazeno
              },
              headers: { Authorization: `Bearer ${businessAdminToken}` }, // Nahrazeno
            }
          );
          setPaymentData(response.data.data);
        } catch (error) {
          console.log("Nejsou data");
        }
      };

      getPaymentData();
    }
  }, [adminBusiness, businessAdminToken]);  // Nahrazeno

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    fetchBusinessAdmin()
  }, [fetchBusinessAdmin]);

  useEffect(() => {
        fetchBusinessAdmin()

  }, [fetchBusinessAdmin])

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (!stripe || !elements) {
      return;
    }
  
    try {
      setLoading(true);
  
      // Vytvoření PaymentMethod z karty
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: elements.getElement(CardElement),
      });
  
      if (error) {
        setMessage(error.message);
        setLoading(false);
        return;
      }
    
      // Volání backendu k vytvoření předplatného a získání clientSecret
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/payments/branch-subscribe`,
        {
          businessId: adminBusiness._id,
          plan,
          paymentMethodId: paymentMethod.id,
        },
        {
          headers: { Authorization: `Bearer ${businessAdminToken}` },
        }
      );
  
    
  
      // clientSecret může být null, pokud je platba hotová (nevyžaduje potvrzení)
      const clientSecret = data.clientSecret;
  
      if (!clientSecret) {
        // Platba je hotová, zobrazíme zprávu z backendu
        setMessage(data.message || "Předplatné zpracováno!");
        setLoading(false);
        return;
      }
  
      // Potvrzení platby přes Stripe, pokud clientSecret existuje
      const confirmPayment = await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethod.id,
      });
  

  
      if (confirmPayment.error) {
        setMessage(confirmPayment.error.message);
      } else if (confirmPayment.paymentIntent && confirmPayment.paymentIntent.status === "succeeded") {
        setMessage("Platba byla úspěšně zpracována!");
      } else {
        setMessage("Platba byla zpracována, čeká na potvrzení.");
      }
    } catch (error) {
      setMessage(error.response?.data?.message || "Došlo k chybě při zpracování platby.");
      console.error("Chyba při zpracování platby:", error);
    } finally {
      setLoading(false);
      fetchBusinessAdmin()
      setTimeout(() => {
        setMessage(null)
      }, 2000)
    }
  };

  const handleCancel = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/payments/branch-cancel`,
        {
          businessId: adminBusiness._id,  // Nahrazeno
        },
        {
          headers: {
            Authorization: `Bearer ${businessAdminToken}`,  // Nahrazeno
          },
        }
      );
      setTimeout(() => {
        window.location.reload();
      }, 1500);
      setMessage(response.data.message);
    } catch (err) {
      console.log(err.response?.data?.message);
    }
  };

  const handleActivate = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/payments/activate-branch`,
        { businessId: adminBusiness._id },  // Nahrazeno
        {
          headers: {
            Authorization: `Bearer ${businessAdminToken}`,  // Nahrazeno
          },
        }
      );
      setMessage(response.data.message);
    } catch (err) {
      setMessage(err.response?.data?.message);
    } finally {
      setTimeout(() => {
        setMessage(null)
        window.location.reload()
      }, 1500)
    }
  };

  const formattedDate = (dateToFormat) => {
    return new Date(dateToFormat).toLocaleDateString("cs-CZ");
  };

  const branchPrice = (number) => {
    const BranchPrice = 99
    const monthlyPrice = Number(process.env.REACT_APP_MONTHLY_ADMIN_PRICE)

    if (number > 3) {
      const ExtraBranch = number - 3
      const totalPrice = ExtraBranch * BranchPrice
      const totalPriceFormonth = totalPrice + monthlyPrice
      return <div>
        <h4 style={{ textAlign: "center" }}>Extra pobočky</h4>
        <p style={{ textAlign: "center" }}>{totalPrice} Kč</p>
        <h3 style={{ textAlign: "center" }}>Celkem </h3>
        <p style={{ textAlign: "center" }}>{totalPriceFormonth} Kč</p>
      </div>
      
    } else {
      return <p>Žádné extra pobočky</p>
    }
  }

  if (!businessAdminToken) {
    return <BusinessLogin />
  }

  return (
    <div className="min-height">
      <Navbar />
      <div className="payment-form-container">
        <h2>Správa předplatného</h2>

        {adminBusiness?.subscriptionStatus === "active" && (  // Nahrazeno
          <div className="subscription-status">
            <p>Předplatné aktivní</p>
          </div>
        )}

        {adminBusiness?.subscriptionStatus === "pending" && (  // Nahrazeno
          <div className="payment-form-container-payment-form">
            <div className="subscription-options">
            <div>
              <h4 style={{ textAlign: "center" }}>Měsíční předplatné</h4>
              <p style={{ textAlign: "center" }}>{process.env.REACT_APP_MONTHLY_ADMIN_PRICE} Kč</p>
            </div>
              <div>
                  {adminBusiness.branches.length > 3 && <div>
                    {branchPrice(adminBusiness.branches.length)}
                  </div>}
            </div>
            </div>
            <form onSubmit={handleSubmit} className="payment-form">
              <CardElement
                options={{
                  hidePostalCode: true,
                  style: {
                    base: {
                      fontSize: "16px",
                      color: "#424770",
                      "::placeholder": {
                        color: "#aab7c4",
                      },
                    },
                    complete: {
                      color: "#424770",
                    },
                    invalid: {
                      color: "#9e2146",
                    },
                  },
                }}
              />
              <button type="submit" className="submit-button">
                Zaplatit
              </button>
            </form>
          </div>
        )}

        {paymentData?.status === "cancelled" && (  // Nahrazeno
          <div className="subscription-status-cancelled">
            <p>Předplatné zrušeno</p>
          </div>
        )}

<div className="payment-history">
      {paymentData.map((item) => {
        return (
          <div key={item._id} className="payment-item">
            {item.isCancellationRequested === "true" ? 
              <div>
                <h3 className="status-cancelled">Zrušeno, platné do: {formattedDate(item.expiryDate)}</h3>
                <button onClick={handleActivate} className="button activate">Obnovit</button> 
              </div>
              : 
              <button onClick={handleCancel} className="button cancel">Zrušit předplatné</button>}
          </div>
        );
      })}
    </div>

        {message && <p className="message">{message}</p>}
        {loading && <div className="loading-spinner"></div>}
      </div>
    </div>
  );
};

const App = () => (
  <Elements stripe={stripePromise} options={{ appearance }}>
    <AdminPaymentForm /> {/* Upraveno */}
  </Elements>
);

export default App;